import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Link from 'components/Link'
import { FlexContainer, FlexItem } from 'components/Flex'
import Icon from 'components/Icon'
import { Dropdown, DropdownItem, DropdownItemIcon } from 'components/Dropdown'
import FloatingActionButton from 'components/FloatingActionButton'
import Avatar from 'components/Avatar'

import logo from 'assets/img/logo-white.png'
import links from 'misc/links'

import { Tabs } from 'components/Tabs'
import { makeSink } from 'components/ComponentSink'

import './header-background@2x.png'
import 'assets/img/logo-white@2x.png'
import './styles.sass'

@observer
export default class Header extends React.Component {
  render () {
    const {
      rootStore: { authStore, desktopNotificationStore, soundStore },
      onClickBack,
      children,
      showTabs,
      small,
      backTo,
      onFabClick,
      fabTo
    } = this.props

    return (
      <header className={cx('app-header animated fadeIn is-faster', small && 'app-header--small')}>
        <Navbar
          user={authStore.user}
          onClickBack={onClickBack}
          backTo={backTo}
          supportsNotifications={desktopNotificationStore.isSupported}
          notificationsEnabled={desktopNotificationStore.isEnabled}
          onToggleNotificationsClick={() => desktopNotificationStore.setEnabled(!desktopNotificationStore.isEnabled)}
          soundEnabled={soundStore.isEnabled}
          onToggleSoundClick={() => soundStore.setEnabled(!soundStore.isEnabled)}
          onLogoutClick={() => authStore.logout()}
        />
        {children || <Welcome user={authStore.user} />}
        {showTabs &&
          <HeaderTabs />
        }
        {(onFabClick || fabTo) &&
          <div className="fab-container">
            <FloatingActionButton
              pull
              large
              icon={<Icon material name="add" />}
              data-test="new-project"
              onClick={onFabClick}
              to={fabTo}
            />
          </div>
        }
      </header>
    )
  }
}

export const HeaderTitle = ({ children, spacingTop, large }) => (
  <div
    className={
      cx(
        'header-title-container',
        spacingTop && 'has-spacing-top',
        large && 'is-large'
      )
    }
  >
    <h1 className={cx('header-title title is-white has-text-centered', !large && 'is-semibold')}>
      {children}
    </h1>
  </div>
)

let Welcome = ({ user }) => (
  <HeaderTitle spacingTop large>
    Welcome {user.name}!
  </HeaderTitle>
)

Welcome = observer(Welcome)

// These are not used at the moment,
// but if they were, the FAB would be in
// the way, which is bad.
const HeaderTabs = ({ children }) => (
  <div className="tab-bar-container animated fadeIn">
    <Tabs>
      {children}
    </Tabs>
  </div>
)

let Navbar = ({ user, onClickBack, backTo, isIndex, ...rest }) => (
  <FlexContainer className="navbar">
    <FlexItem>
      {onClickBack || backTo
        ? (
          <BackButton onClick={onClickBack} backTo={backTo} isIndex={isIndex} />
        )
        : (
          <Link to="/" className="brand animated fadeIn">
            <img src={logo} alt="Taxfyle" className="logo" />
          </Link>
        )
      }

    </FlexItem>
    <FlexItem stretch />
    <FlexItem>
      <UserInfo
        name={user.name}
        avatar={user.avatar}
      />
    </FlexItem>
    <FlexItem>
      <NavbarActions {...rest} />
    </FlexItem>
  </FlexContainer>
)

Navbar = observer(Navbar)

const UserInfo = ({ avatar, name }) => (
  <div className="user-info animated fadeIn">
    <FlexContainer>
      <FlexItem vcentered>
        <Avatar size={24} url={avatar} alt={name} className="avatar" />
      </FlexItem>
      <FlexItem className="name">
        {name}
      </FlexItem>
    </FlexContainer>
  </div>
)

// const NavbarActions = () => (
//   <div className="actions animated fadeIn">
//     <Link to={links.logout()} className="action button is-icon-only is-white is-faded" title="Log out">
//       <Icon material name="power settings new" />
//     </Link>
//   </div>
// )

const NavbarActions = ({
  supportsNotifications,
  notificationsEnabled,
  onToggleNotificationsClick,
  soundEnabled,
  onToggleSoundClick,
  onLogoutClick
}) => (
  <div className="actions animated fadeIn">
    <Dropdown
      position="right"
      button={
        <a className="action button is-icon-only is-white is-faded" data-test="toggle-header-dropdown">
          <Icon material name="more vert" />
        </a>
      }
    >
      <DropdownItem to={links.profile()} data-test="goto-profile">
        <DropdownItemIcon material name="account circle" />
        Account
      </DropdownItem>
      <DropdownItem to={links.billing()} data-test="goto-billing">
        <DropdownItemIcon material name="credit card" />
        Billing
      </DropdownItem>
      <DropdownItem to={links.allDocuments()} data-test="goto-all-documents">
        <DropdownItemIcon material name="attach file" />
        All Documents
      </DropdownItem>
      {/* <DropdownItem to={links.linkedAccounts()} data-test="goto-linked-accounts"> */}
        {/* <DropdownItemIcon material name="account balance" /> */}
        {/* Linked Accounts */}
      {/* </DropdownItem> */}
      <DropdownItem to={links.coupons()} data-test="goto-coupons">
        <DropdownItemIcon material name="attach money" />
        Coupons
      </DropdownItem>
      <DropdownItem to={links.referAFriend()} data-test="refer-a-friend">
        <DropdownItemIcon material name="group" />
        Refer a Friend
      </DropdownItem>
      <hr />
      {supportsNotifications &&
        <DropdownItem onClick={() => onToggleNotificationsClick()}>
          <DropdownItemIcon material name={notificationsEnabled ? 'notifications' : 'notifications off'} />
          {notificationsEnabled ? 'Notifications enabled' : 'Notifications disabled'}
        </DropdownItem>
      }
      <DropdownItem onClick={() => onToggleSoundClick()}>
        <DropdownItemIcon material name={soundEnabled ? 'volume up' : 'volume off'} />
        {soundEnabled ? 'Sound enabled' : 'Sound muted'}
      </DropdownItem>
      <hr />
      <DropdownItem onClick={() => onLogoutClick()} data-test="logout">
        <DropdownItemIcon material name="power settings new" />
        Log out
      </DropdownItem>
    </Dropdown>
  </div>
)

const BackButton = ({ onClick, backTo, isIndex }) => {
  const Button = (props) => <button {...props} onClick={onClick} />
  const LinkComponent = (props) => <Link index={isIndex} {...props} to={backTo} />
  const ButtonComponent = backTo
    ? LinkComponent
    : Button

  return (
    <ButtonComponent className="button is-icon-only is-white is-faded animated fadeIn" data-test="header-back-button">
      <Icon material medium name="arrow back" />
    </ButtonComponent>
  )
}

// The following 2 components lets us declare props for the header
// in sub components, even though the actual header is mounted further up the tree.
// This is used to prevent remounting with React Router, which will kill certain
// animations.
const { Sink, Renderer } = makeSink(Header)
export const HeaderRenderer = Renderer
export const HeaderSink = Sink



// WEBPACK FOOTER //
// ./src/client/components/Header/index.jsx